'use client'

interface ProductList {
  sku: string
  isAvailable: boolean
  isActive: boolean
}

interface ShouldSuggestProductsParams {
  forgotSomethingProducts?: ProductList[]
  timeToSuggest: number
}

export const shouldSuggestProducts = ({
  forgotSomethingProducts = [],
  timeToSuggest,
}: ShouldSuggestProductsParams): boolean => {
  const item: string | null = sessionStorage.getItem('lastSuggestionTime')
  const lastSuggestionTime =
    (new Date().getTime() - new Date(item || '').getTime()) / 1000
  const isEnabled =
    Number.isNaN(lastSuggestionTime) || lastSuggestionTime > timeToSuggest

  return isEnabled && forgotSomethingProducts.length > 0
}
